import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=5f39312a&scoped=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=5f39312a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f39312a",
  null
  
)

export default component.exports